<template>
    <main>
        <section class="home">
            <div class="left-games">
                <h2>Ces jeux-là, on adore</h2>
                <div class="slider"></div>

                <div class="featured-games">
                    <div class="games-container">
                        <div class="jeu-container" v-for="i in 3" :key="i">
                            <div class="jeu">
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="clickers-games">
                    <div class="title-btn">
                        <h2>Pour cliquer à l'infini...</h2>
                        <a class="more">Voir +</a>
                    </div>
                    <div class="games-container">
                        <div class="jeu-container" v-for="i in 6" :key="i">
                            <div class="jeu">
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-games">
                <div class="random-games">
                    <h2>Découvre maintenant</h2>
                    
                    <div class="games-container">
                        <div class="jeu-container" v-for="i in 6" :key="i">
                            <div class="jeu">
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-games">
                    <h2>Nouveaux jeux</h2>
                    <div class="games-container">
                        <div class="jeu-container" v-for="i in 6" :key="i">
                            <div class="jeu">
                                <div class="img"></div>
                                <div class="contenu">
                                    <p>Titre du jeu</p>
                                    <span>Joué 0 fois</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="last-played-games"></div>
            </div>
        </section>
        
        <div class="about">
            <h3>À propos de Games™ par ClickTestCPS.fr</h3>

            <p>Découvrez une sélection de plusieurs centaines de jeux en ligne gratuits. Mettez à profit votre capacité à cliquer rapidement avec nos Jeux de Clickers. Défiez votre cerveau grâce à de superbes Jeux de Réflexion. Déchaînez-vous en vous amusant en jouant à nos Jeux d'Action ! Enfin, prenez le contrôle du bitume à travers nos Jeux de Course forts en sensation. Découvrez nos catégories en cliquant ici.</p>
            
            <p>Nous ajoutons quotidiennement de nouveaux jeux pour vous permettre de vous divertir sans limites. Défiez vos amis et des milliers de joueurs en ligne chaque mois. Vous pouvez être sûr que nous vous proposons ici les meilleurs jeux du net !</p>
        </div>

    </main>
</template>

<script>
    export default {
        name: 'SkeletonHome'
    }
</script>

<style scoped src="@/assets/home.css">
</style>
<style scoped src="@/assets/slider.css">
</style>
<style scoped src="@/assets/gamesFeed.css">
</style>
<style scoped src="@/assets/skeletonHome.css">
</style>